module.exports = __webpack_public_path__ + "img/swift-sport.6792b21c.png";